import React, {useEffect, useState} from 'react';
import {
    Box,
    Button,
    Checkbox,
    CircularProgress,
    Container,
    FormControl,
    FormControlLabel,
    FormGroup,
    Grid,
    Modal,
    Paper,
    Typography
} from "@material-ui/core";
import {Alert} from "@material-ui/lab";
import useStyles from "../../styles/styles";
import useFormInputs from "../../hooks/useFormInputs";
import stateMap from "../../utils/stateMap";
import {Prism as SyntaxHighlighter} from "react-syntax-highlighter";
import {base16AteliersulphurpoolLight} from "react-syntax-highlighter/dist/cjs/styles/prism";
import {CopyToClipboard} from "react-copy-to-clipboard";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import RenderInput from "../TrafficSource/RenderInput";

const StateModal = ({data, modalData, closeModal, setStateList}) => {
    const classes = useStyles();
    const [list, setList] = useState([]);
    const [isError, setIsError] = useState(false);
    const [submitLoading, setSubmitLoading] = useState(false);
    const onSubmit = () => {
        setSubmitLoading(true);
        setIsError(false);
        let error = false;

        if (!list.length) {
            error = true;
        }

        if (!error) {
            const stateList = list.join(',')
            setStateList(stateList)
            closeModal()
        } else {
            setSubmitLoading(false);
            setIsError(error);
        }
    };
    const {inputs, handleInputChange, handleSubmit, setInputs} = useFormInputs(onSubmit);

    const isValidState = (type, state) => {
        const arr = stateMap.filter(stateItem => {
            const value = stateItem[type].toLowerCase().replaceAll(/\s/g, '');
            return state && value === state.toLowerCase();
        });
        return arr;
    };
    useEffect(() => {
        if (modalData) {
            if (modalData.value) {
                const newList = modalData.value.includes('\n') ? modalData.value.split('\n') : modalData.value.includes(',') ? modalData.value.split(',') : [modalData.value];
                setList(newList);
            }
            setInputs(inputs => ({
                ...inputs,
            }));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [modalData]);

    useEffect(() => {
        if (list) {
            if ((new Set(list)).size !== list.length)
                setList([...new Set(list)].sort());
        }
    }, [list]);

    const selectState = (e, state) => {
        if (e.target.checked) {
            if (state === 'all') {
                const newList = stateMap.map(item => item.value);
                setList(newList);
            } else {
                setList(prevState => [...prevState, state.value]);
            }
        } else {
            if (state === 'all') {
                setList([]);
            } else {
                const arr = list.filter(item => item !== state.value);
                setList(arr);
            }
        }
    };

    const renderCopyButton = () => (
        <CopyToClipboard text={list}>
            <Box display="flex" alignItems="center" justifyContent="center" style={{margin: '10px 0'}}>
                <Button
                    variant="contained"
                    color="primary"
                    startIcon={<FileCopyIcon/>}
                >
                    Copy Raw
                </Button>
            </Box>
        </CopyToClipboard>
    );
    return (
        <Modal
            open={true}
            onClose={closeModal}
        >
            <Container className={classes.modal} maxWidth={false}>
                <Paper className={classes.paper} style={{marginBottom: 0, overflow: 'hidden'}}>
                    <Typography variant="h5" align="center" gutterBottom>
                        Build the State List Below.
                    </Typography>
                    {isError ? (
                        <Alert severity="error" style={{marginBottom: '5px'}}>
                            Please add values to the highlighted fields!
                        </Alert>
                    ) : false}
                    <Grid container spacing={3} style={{padding: '10px'}}>
                        <Grid container spacing={3} style={{padding: '10px'}}>
                            <Grid item xs={9}>
                                <RenderInput
                                    item={{
                                        label: 'Manually Enter States with Comma',
                                        key: 'states',
                                        type: 'text',
                                        required: false
                                    }}
                                    value={inputs.states || ''}
                                    data={data}
                                    handleFilterChange={null}
                                    handleInputChange={handleInputChange}
                                    handleSwitchChange={null}
                                />
                            </Grid>
                            <Grid item xs={3}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={() => {
                                        const states = inputs.states.trim();
                                        if (states.includes(',')) {
                                            const arr = states.replaceAll(/\s/g, '').split(',');
                                            const newStates = [];
                                            arr.forEach(item => {
                                                const isState = isValidState('value', item);
                                                if (isState.length) {
                                                    newStates.push(isState[0].value);
                                                }
                                            });
                                            if (newStates.length) {
                                                setList(prevState => [...prevState, ...newStates]);
                                            }
                                        } else {
                                            const newState = isValidState('value', states);
                                            if (newState.length) {
                                                setList(prevState => [...prevState, states]);
                                            }
                                        }
                                    }}
                                >
                                    Update List
                                </Button>
                            </Grid>
                        </Grid>
                        <Grid item xs={9} style={{padding: 0}}>
                            <Grid container spacing={3} style={{padding: '10px'}}>
                                <Grid item xs={12}>
                                    <Button
                                        variant="contained"
                                        className={classes.deleteButton}
                                        onClick={() => {
                                            setList([]);
                                        }}
                                    >
                                        Clear All
                                    </Button>
                                </Grid>
                            </Grid>
                            <FormControl className={classes.formControl}>
                                <FormGroup>
                                    <Grid container>
                                        <Grid item xs={3}>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        defaultChecked={stateMap.length === list.length}
                                                        onChange={(e) => selectState(e, 'all')}
                                                        name='all'
                                                    />
                                                }
                                                label={
                                                    <Box
                                                        display="flex"
                                                        alignItems="flex-start"
                                                        justifyContent="space-between"
                                                        flexDirection="column"
                                                    >
                                                        <Typography
                                                            variant="body2"
                                                            style={{paddingBottom: '5px'}}
                                                        >
                                                            Select All
                                                        </Typography>
                                                    </Box>
                                                }
                                            />
                                        </Grid>
                                        {stateMap.map(item => {
                                            const isChecked = list.length ? list.includes(item.value) : false;
                                            return (
                                                <Grid key={item.value} item xs={3}>
                                                    <FormControlLabel
                                                        key={item.value}
                                                        control={
                                                            <Checkbox
                                                                checked={isChecked}
                                                                onChange={(e) => selectState(e, item)}
                                                                name={item.value}
                                                            />
                                                        }
                                                        label={
                                                            <Box
                                                                display="flex"
                                                                alignItems="flex-start"
                                                                justifyContent="space-between"
                                                                flexDirection="column"
                                                            >
                                                                <Typography
                                                                    variant="body2"
                                                                    style={{paddingBottom: '5px'}}
                                                                >
                                                                    {item.value} <br/>
                                                                    <small>{item.name}</small>
                                                                </Typography>
                                                            </Box>
                                                        }
                                                    />
                                                </Grid>
                                            );
                                        })}
                                    </Grid>
                                </FormGroup>
                            </FormControl>
                        </Grid>
                        <Grid item xs={3} style={{padding: 0}}>
                            <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center">
                                <Typography variant="body1">
                                    <strong>JSON State List Preview</strong>
                                    {renderCopyButton()}
                                </Typography>
                            </Box>
                            <Box style={{height: '550px', overflow: 'scroll'}}>
                                <SyntaxHighlighter language="json" style={base16AteliersulphurpoolLight}>
                                    {JSON.stringify(list, null, 1)}
                                </SyntaxHighlighter>
                            </Box>
                        </Grid>
                    </Grid>
                    <Box
                        display={"flex"}
                        alignItems={"center"}
                        style={{margin: '10px 0'}}
                        justifyContent={"center"}>
                        <Box style={{marginRight: '10px'}}>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={() => {
                                    handleSubmit();
                                }}
                                disabled={submitLoading}
                            >
                                {submitLoading ? (
                                    <CircularProgress color="inherit"/>
                                ) : (
                                    <>
                                        Save Values
                                    </>
                                )}
                            </Button>
                        </Box>
                        <Box>
                            <Button
                                variant="contained"
                                color="secondary"
                                onClick={() => {
                                    closeModal();
                                }}
                            >
                                Cancel
                            </Button>
                        </Box>
                    </Box>
                </Paper>
            </Container>
        </Modal>
    );
};

export default StateModal;
